module.exports = __webpack_public_path__ + "img/semsenha-2019-bk.a2e77d60.svg";